var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.sale.ContactID
    ? _c(
        "w-row",
        { staticClass: "npb" },
        [
          _c(
            "w-col",
            { attrs: { md: "12", lg: "5" } },
            [
              _c("app-contact-search", {
                attrs: {
                  fancy: "",
                  value: _vm.sale.Contact,
                  "group-id": _vm.groupId,
                  label: _vm.$ct(`contact-choose-${_vm.groupId}`),
                  "auto-focus": _vm.autoFocus,
                  "top-margin": 5,
                },
                on: {
                  input: function ($event) {
                    return _vm.onContactSelect($event)
                  },
                  "update-group": function ($event) {
                    return _vm.state.setContactGroupId($event)
                  },
                },
              }),
            ],
            1
          ),
          _c("w-spacer"),
          _c(
            "w-col",
            { attrs: { sm: "12", md: "7" } },
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c("w-spacer"),
                  !_vm.$wf.isSmDown
                    ? _c(
                        "w-button",
                        {
                          style: { marginBottom: "10px" },
                          attrs: { right: "" },
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$ct("finish", { type: _vm.saleTypeName })
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "w-row",
                { style: { marginTop: "2px" }, attrs: { "no-margin": "" } },
                [
                  _c("w-spacer"),
                  _c(
                    "w-col",
                    { attrs: { sm: "4", md: "4", lg: "3" } },
                    [
                      !_vm.isSubscription
                        ? _c("app-sale-type-select", {
                            attrs: {
                              value: _vm.sale.Type,
                              "ignored-type-ids": [10],
                              "use-object": "",
                              label: _vm.$ct("type-choose"),
                              "contact-group-id": _vm.state.getContactGroupID(),
                              fancy: "",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onTypeChange($event)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { sm: "4", md: "4", lg: "3" } },
                    [
                      _c("app-sale-edit-vat-regime-select", {
                        attrs: {
                          state: _vm.state,
                          label: _vm.$ct("vat-regime"),
                          fancy: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    {
                      style: { paddingRight: "0px" },
                      attrs: { sm: "4", md: "4", lg: "3" },
                    },
                    [
                      _c("app-sell-category-select", {
                        attrs: {
                          label: _vm.$ct("price-category-choose"),
                          fancy: "",
                          "active-only": "",
                        },
                        model: {
                          value: _vm.sale.PriceCategory,
                          callback: function ($$v) {
                            _vm.$set(_vm.sale, "PriceCategory", $$v)
                          },
                          expression: "sale.PriceCategory",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.isAllowedMultiLanguages || _vm.isAllowedMultiValuta
                    ? _c(
                        "w-col",
                        {
                          style: {
                            display: "flex",
                            flexDirection: "row",
                            paddingRight: "0",
                          },
                          attrs: { sm: "4", md: "4", lg: "3" },
                        },
                        [
                          _vm.isAllowedMultiValuta
                            ? _c("app-currency-select", {
                                staticClass: "mrs",
                                style: { flexGrow: 1 },
                                attrs: { fancy: "" },
                                model: {
                                  value: _vm.sale.CurrencyID,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.sale, "CurrencyID", $$v)
                                  },
                                  expression: "sale.CurrencyID",
                                },
                              })
                            : _vm._e(),
                          _vm.isAllowedMultiLanguages
                            ? _c("app-custom-language-select", {
                                style: { flexGrow: 1 },
                                attrs: {
                                  value: _vm.sale.Lng,
                                  label: _vm.$ct("language-select"),
                                  fancy: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.setLng($event)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "w-row",
        { attrs: { "no-margin": "" } },
        [
          !_vm.isMobile
            ? _c(
                "div",
                { staticClass: "edit-box" },
                [
                  !_vm.isMobile
                    ? _c(
                        "w-link",
                        {
                          staticClass: "sale-edit link mls mr",
                          on: {
                            click: function ($event) {
                              return _vm.openEditContact()
                            },
                          },
                        },
                        [
                          _c("w-fa", { attrs: { icon: "edit" } }),
                          _vm._v(" " + _vm._s(_vm.$ct("edit-contact")) + " "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "w-link",
                    {
                      staticClass: "sale-edit link ml",
                      on: {
                        click: function ($event) {
                          return _vm.clearContact()
                        },
                      },
                    },
                    [
                      _c("w-fa", { attrs: { icon: "search" } }),
                      _vm._v(" " + _vm._s(_vm.$ct("switch-contact")) + " "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("w-spacer"),
          _c(
            "w-col",
            { attrs: { sm: "12", md: "7", "no-margin": "" } },
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  !(_vm.isAllowedMultiLanguages || _vm.isAllowedMultiValuta)
                    ? _c("w-col", { attrs: { sm: "4", lg: "3" } })
                    : _vm._e(),
                  _c(
                    "w-col",
                    { attrs: { sm: "4", md: "4", lg: "3" } },
                    [
                      !_vm.isSubscription
                        ? _c("app-sale-type-select", {
                            attrs: {
                              "ignored-type-ids": _vm.ignoredTypes,
                              value: _vm.sale.Type,
                              "use-object": "",
                              label: _vm.$ct("type-choose"),
                              "contact-group-id": _vm.state.getContactGroupID(),
                              fancy: "",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onTypeChange($event)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { sm: "4", md: "4", lg: "3" } },
                    [
                      _c("app-sale-edit-vat-regime-select", {
                        attrs: {
                          state: _vm.state,
                          label: _vm.$ct("vat"),
                          fancy: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { sm: "4", md: "4", lg: "3" } },
                    [
                      _c("app-sell-category-select", {
                        attrs: {
                          label: _vm.$ct("price-category-choose"),
                          "active-only": "",
                          fancy: "",
                        },
                        model: {
                          value: _vm.sale.PriceCategory,
                          callback: function ($$v) {
                            _vm.$set(_vm.sale, "PriceCategory", $$v)
                          },
                          expression: "sale.PriceCategory",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.isAllowedMultiLanguages || _vm.isAllowedMultiValuta
                    ? _c(
                        "w-col",
                        {
                          style: {
                            display: "flex",
                            flexDirection: "row",
                            paddingRight: "0",
                          },
                          attrs: { sm: "4", md: "4", lg: "3" },
                        },
                        [
                          _vm.isAllowedMultiValuta
                            ? _c("app-currency-select", {
                                staticClass: "mrs",
                                style: { flexGrow: 1 },
                                attrs: { fancy: "" },
                                model: {
                                  value: _vm.sale.CurrencyID,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.sale, "CurrencyID", $$v)
                                  },
                                  expression: "sale.CurrencyID",
                                },
                              })
                            : _vm._e(),
                          _vm.isAllowedMultiLanguages
                            ? _c("app-custom-language-select", {
                                style: { flexGrow: 1 },
                                attrs: {
                                  value: _vm.sale.Lng,
                                  label: _vm.$ct("language-select"),
                                  fancy: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.setLng($event)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              attrs: { "escape-close": "", "full-height": "" },
              model: {
                value: _vm.editContactModal,
                callback: function ($$v) {
                  _vm.editContactModal = $$v
                },
                expression: "editContactModal",
              },
            },
            [
              _c(
                "w-card",
                { staticClass: "edit-contact-card" },
                [
                  _c(
                    "w-card-title",
                    [
                      _vm._v(" " + _vm._s(_vm.$ct("edit-contact")) + " "),
                      _c("w-spacer"),
                      _c(
                        "w-link",
                        {
                          staticClass: "mrs",
                          attrs: { white: "" },
                          on: {
                            click: function ($event) {
                              _vm.editContactModal = false
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "times" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.sale.ContactID
                    ? _c("app-edit-contact", {
                        ref: "root",
                        attrs: {
                          id: _vm.sale.ContactID,
                          value: _vm.sale.Contact,
                        },
                        on: {
                          save: function ($event) {
                            _vm.editContactModal = false
                          },
                          input: function ($event) {
                            return _vm.state.selectContact($event)
                          },
                          cancel: function ($event) {
                            _vm.editContactModal = false
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }